import { usePersonCountries } from 'shared/hooks/(wallets)/kyc/usePersonCountries';
import { useSupportedCurrencies } from 'shared/hooks/(wallets)/kyc/useSupportedCurrencies';

export const useFormData = () => {
    // we are using personal countries here, which is fine,  because we
    // don't have any specific endpoint for company countries and we don't have
    // static data within web-app.
    const { countries, isCountriesLoading } = usePersonCountries();
    const { currencies, isCurrenciesLoading } = useSupportedCurrencies();

    return {
        countries,
        currencies,
        isCountriesLoading,
        isCurrenciesLoading,
    };
};
